import React, { useState } from 'react'
import clsx from 'clsx'
import { isNil } from 'ramda'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { MenuItem, Typography } from '@material-ui/core'
import PersonAddIcon from '@material-ui/icons/PersonAdd'

import { InfoIcon } from 'app/components/icons'
import { SECONDARY } from 'app/constants/button'
import { CRM_LIMIT, SubscriberMenuAction } from 'app/constants/subscriberCRM'

import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'

import InviteLimitExceedDialog from '../InviteLimitExceedDialog'

const Invite = (props) => {
  const {
    closeMenu = () => {},
    onAction,
    rootAdmin = {},
    selected = [],
    selectedCount = null,
    totalSelected = null,
  } = props

  const { formatMessage } = useIntl()
  const [isOpen, setIsOpen] = useState(false)
  const [isShowLimitDialog, setIsShowLimitDialog] = useState(false)

  const MAX_INVITE_LIMIT = {
    number: CRM_LIMIT,
    text: CRM_LIMIT.toString(),
  }

  const handleOpen = () => {
    if (selectedCount > MAX_INVITE_LIMIT.number) {
      setIsShowLimitDialog(true)
    } else {
      setIsOpen(true)
    }
  }

  const handleClose = () => {
    setIsOpen(false)
    closeMenu()
  }

  return (
    <div>
      {!isNil(rootAdmin) && selectedCount > 0 && (
        <div className="flex gap-2 items-center">
          <Typography
            className={clsx(
              'text-14 text-primary font-500 cursor-pointer whitespace-nowrap',
            )}
            onClick={handleOpen}
          >
            {formatMessage(
              {
                id: 'action.invite',
              },
              { value: `(${selectedCount.toLocaleString()})` },
            )}
          </Typography>
          <PrimaryTooltip
            title={formatMessage({
              id: 'invite.tooltip.message',
            })}
          >
            <div>
              <InfoIcon
                className="w-20 flex"
                width="14"
                height="14"
                color="#183560"
              />
            </div>
          </PrimaryTooltip>
        </div>
      )}
      {isNil(selectedCount) && (
        <MenuItem onClick={() => handleOpen()} className="space-x-5">
          <PersonAddIcon fontSize="small" className="text-blue-500" />
          <Typography className="text-14 font-400 text-blue-500">
            {formatMessage(
              {
                id: 'action.invite',
              },
              {
                value: null,
              },
            )}
          </Typography>
        </MenuItem>
      )}

      <SubmitDialog
        id="dialog-invite-subscriber"
        open={isOpen}
        type={SECONDARY}
        title={formatMessage(
          {
            id: 'subscriber.invite.title',
          },
          {
            count: selectedCount || 0,
          },
        )}
        description={formatMessage(
          {
            id: 'subscriber.invite.description',
          },
          {
            count: isNil(selectedCount) ? 1 : selectedCount,
          },
        )}
        submitText={formatMessage(
          {
            id: 'action.invite',
          },
          {
            value: null,
          },
        )}
        onSubmit={() => {
          onAction(SubscriberMenuAction.INVITE, selected)
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />

      <InviteLimitExceedDialog
        isShowLimitDialog={isShowLimitDialog}
        setIsShowLimitDialog={setIsShowLimitDialog}
        selected={selected}
        onAction={onAction}
        MAX_INVITE_LIMIT={MAX_INVITE_LIMIT}
      />
    </div>
  )
}

Invite.propTypes = {
  onAction: PropTypes.func,
  selected: PropTypes.array,
  closeMenu: PropTypes.func,
  className: PropTypes.string,
  rootAdmin: PropTypes.object,
  selectedCount: PropTypes.number,
}

export default Invite
